import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RewardRule } from '../../../../../rewards/models/rewards-v2.models';
import {
  formatRewardRuleAmount,
  formatRewardRuleItemsRequired,
  formatRewardRuleServiceType,
  formatRewardRuleWashTypes,
} from '../../utils/reward-rule-display.util';

@Component({
  selector: 'app-reward-rule-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reward-rule-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reward-rule-card.component.scss'],
})
export class RewardRuleCardComponent {
  @Input({ required: true }) rule!: RewardRule;
  @Input() packageNameById: ReadonlyMap<string, string> = new Map();
  @Output() editClick = new EventEmitter<RewardRule>();
  @Output() disableClick = new EventEmitter<RewardRule>();

  get rewardAmount(): string {
    return formatRewardRuleAmount(this.rule.amount);
  }

  get serviceLabel(): string {
    return formatRewardRuleServiceType(this.rule.service_type);
  }

  get washTypeLabel(): string {
    return formatRewardRuleWashTypes(this.rule, this.packageNameById);
  }

  get itemsRequiredLabel(): string {
    return formatRewardRuleItemsRequired(this.rule.items_sold);
  }
}
